import {
  CREATE_EVENT,
  EDIT_EVENT,
  FETCH_EVENT,
  FETCH_BUYER_EVENTS,
  FETCH_EVENTs,
  APPROVE_EVENT,
} from "../../actions/types";
import _ from "lodash";

const eventReducers = (state = {}, action) => {
  switch (action.type) {
    case EDIT_EVENT:
    case APPROVE_EVENT:
    case FETCH_EVENT:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };

    case CREATE_EVENT:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };

    case FETCH_EVENTs:
    case FETCH_BUYER_EVENTS:
      // If status is provided, remove all events with that status first
      // then add the new events from the payload
      if (action.status) {
        // Filter out events with the same status as the incoming data
        const filteredState = _.omitBy(state, (event) => event.status === action.status);
        // Add new events from the API response
        return { ...filteredState, ..._.mapKeys(action.payload, "id"), loading: false };
      }
      // Fallback to old behavior if no status provided
      return { ...state, ..._.mapKeys(action.payload, "id"), loading: false };

    default:
      return state;
  }
};

export default eventReducers;
